import * as React from "react";

export type ViewAllBtnProps = {
    onClick: Function,
    text: string,
    linkUrl: string
}

export class ViewAllBtn extends React.PureComponent<ViewAllBtnProps, {}>{
    render() {
        return (
            <div className="rj-ev-list__view-all-btn__wrap" data-uat="div-ev-list-view-all-btn-wrap">
                <a className="rj-ev-list__view-all-btn__link" href={this.props.linkUrl} onClick={(e) => this.props.onClick(e)} data-uat="div-ev-list-view-all-btn-link">
                    <span className="rj-ev-list__view-all-btn__text" data-uat="span-ev-list-view-all-btn-text">{this.props.text}</span>
                </a>
            </div>
        )
    }
}